<template>
    <v-layout column>
        <v-layout row wrap>
            <avatar :image="user_page.avatar" class="flex lg3 md4 sm6 xs12" />
            <v-flex lg9 md12 :class="{'mx-3': $vuetify.breakpoint.xs}">
                <v-layout column justify-center :class="{'pl-5': $vuetify.breakpoint.lgAndUp}">
                    <div class="display-1" data-test="username" v-html="user_page.family + ' ' + user_page.name + ' '+ user_page.patronymic">
                    </div>

                    <v-layout row
                              class="grey-text" :class="{'mt-2': $vuetify.breakpoint.lgAndUp}"
                    >
                        <iconLabel v-if="user_page.specialization_value" icon_name="bag" :no_pointer="true"
                                   class="pr-3 flex md4 mt-2" size="20"
                        >
                            {{ user_page.specialization_value }}
                        </iconLabel>
                        <iconLabel v-if="user_page.position" icon_name="document" :no_pointer="true"
                                   class="pr-3 flex md4 mt-2" size="20"
                        >
                            {{ user_page.position }}
                        </iconLabel>
                        <iconLabel v-if="user_page.role_value" user_page.role_value icon_name="role"
                                   :no_pointer="true"
                                   class="pr-3 flex md4 mt-2" size="20"
                        >
                            {{ user_page.role_value }}
                        </iconLabel>
                    </v-layout>
                    <userStats :user='user_page' class="mt-4 border-bottom pb-3" />
                    <!--<userProfileCertificates :user="user_page"/>-->
                    <v-layout v-if="user_page.company_name" class="mt-4 align-center wrap">
                        <v-layout align-center>
                            <div class="mr-3">
                                <img v-if="company_info.image" :src="company_info.image" alt="company logo"
                                     style="width: 48px;"
                                >
                            </div>
                            <v-flex>
                                <div class="text-uppercase">{{ company_info.name }}</div>
                                <div class="grey-text">{{ $t("Рейтинг организации") }} <span class="green-text">{{ company_info.rating }}</span> </div>
                            </v-flex>
                        </v-layout>
                        <v-flex xs12 sm6>
                            <v-layout :class="{'justify-end': $vuetify.breakpoint.smAndUp}">
                                <buttonBdWhite :class="{'flex xs12 mt-3': $vuetify.breakpoint.xs}" @click.native="go_to_org">{{ $t("Профиль организации") }}</buttonBdWhite>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
        </v-layout>
        <userAchievments class="mt-5" :user_page="user_page" />
        <userInfo :user_page="user_page" />
    </v-layout>
</template>

<script>
import avatar   from '@/components/blocks/avatar/avatar_profile.vue';
import iconLabel   from '@/components/ui/icons/icon_with_label.vue';
import userStats   from './user_profile/user_profile_stats.vue';
import userAchievments   from './user_profile/user_profile_achievments.vue';
import userInfo   from './user_profile/user_profile_info.vue';
import userProfileCertificates from './user_profile/user_profile_certificates';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
  components: {
    avatar,
    iconLabel,
    userStats,
    buttonBdWhite,
    userAchievments,
    userInfo,
    userProfileCertificates,
  },
  props: {
    user_page: {
      type: Object,
    },
  },
  computed: {
    ...mapState('company_profile/info', ['rating', 'name']),
    ...mapGetters('company_profile/info', ['company_info']),
    ...mapGetters('profile/user', ['user_id']),
  },
  methods: {
    go_to_org() {
      this.$router.push({name: 'company_other', params: {id: this.user_page.company_id}});
    },
  },
};
</script>
